module.exports = __webpack_public_path__ + "svg/new-jcb-small.aac6406ccd05dc3d23bc31414f92c60c.svg";